import ButtonIcon from "#common/buttons/ButtonIcon"
import { ViewPdfDialog } from "#core/components/view-pdf/ViewPdf"
import { promotionDetailsIdFileIdGet } from "#promotions/services/api"
import DeleteIcon from "@mui/icons-material/Delete"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { Stack } from "@mui/material"
import { Fragment, useCallback, useMemo, useState } from "react"
import FileDialogDelete from "./file-dialog/FileDialogDelete"
import { usePromotionsContext } from "#promotions/PromotionContext"

export default function FileButtons({ data }) {
	const { is_enabled } = usePromotionsContext()
	const [open, setOpen] = useState(false)
	const paramsDialog = useCallback(
		(name) => ({ open: open === name, setOpen, data }),
		[data, open]
	)
	const params = useMemo(
		() => ({
			id: data.promotion_detail,
			fileId: data.id,
			params: { sign: true },
		}),
		[data.id, data.promotion_detail]
	)

	return (
		<Fragment>
			<Stack
				direction={"row"}
				spacing={1}
				justifyContent={"center"}
				alignContent={"center"}
				width={"100%"}
			>
				<ButtonIcon
					title="Borrar"
					icon={<DeleteIcon />}
					onClick={() => setOpen("borrar")}
					hidden={!is_enabled}
				/>

				<ButtonIcon
					title="Ver"
					icon={<VisibilityIcon />}
					onClick={() => setOpen("pdf")}
				/>
			</Stack>
			<FileDialogDelete {...paramsDialog("borrar")} />
			<ViewPdfDialog
				{...paramsDialog("pdf")}
				apiGet={promotionDetailsIdFileIdGet}
				moreParams={params}
			/>
		</Fragment>
	)
}
